import type { ApiError } from '@/types/api';

export type ShowcaseErrorKind =
  | 'no_tariff'
  | 'promo_not_found'
  | 'promo_invalid'
  | 'validation'
  | 'unknown';

function isPromoRelatedMessage(message: string): boolean {
  const lower = message.toLowerCase();
  return lower.includes('promo') || lower.includes('промокод');
}

/**
 * Classifies showcase API errors per domain rules:
 * - 404 without promo → no active tariff
 * - 404 with promo → unknown promo code
 * - 422 with promo → expired/exhausted or other promo validation
 */
export function classifyShowcaseError(
  error: ApiError,
  hasPromo: boolean,
): ShowcaseErrorKind {
  const status = error.code;

  if (status === '404') {
    return hasPromo ? 'promo_not_found' : 'no_tariff';
  }

  if (status === '422') {
    if (hasPromo) {
      return 'promo_invalid';
    }
    return 'validation';
  }

  if (hasPromo && isPromoRelatedMessage(error.message)) {
    return 'promo_invalid';
  }

  return 'unknown';
}

export function getShowcaseErrorMessage(
  kind: ShowcaseErrorKind,
  fallback?: string,
): string {
  switch (kind) {
    case 'no_tariff':
      return 'Для выбранного бокса нет активного тарифа';
    case 'promo_not_found':
      return 'Промокод не найден';
    case 'promo_invalid':
      return 'Промокод недействителен или истёк';
    case 'validation':
      return 'Не удалось рассчитать стоимость. Проверьте параметры аренды';
    default:
      return fallback || 'Не удалось загрузить цены';
  }
}
